import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { hasPermission } from '../config/permissions';

const ProtectedRoute = ({ children, requiredPermission, requireGlobal, requiredRoles }) => {
    const { currentUser, userRole, dynamicServerId } = useAuth();

    if (!currentUser) return <Navigate to="/" />;
    if (!userRole) return children; 

    if (requiredRoles && !requiredRoles.includes(userRole)) {
        const fallback = userRole === 'Support' ? "/support" : `/servers/${dynamicServerId}`;
        return <Navigate to={fallback} />;
    }

    if (requiredPermission && !hasPermission(userRole, requiredPermission)) {
        const fallback = userRole === 'Support' ? "/support" : `/servers/${dynamicServerId}`;
        return <Navigate to={fallback} />;
    }

    // Local Admin Global View Bounce
    if (requireGlobal && !hasPermission(userRole, 'CAN_VIEW_GLOBAL_DASHBOARD')) {
        return <Navigate to={`/servers/${dynamicServerId}`} />;
    }

    return children;
};

export default ProtectedRoute;